const articleSummary = document.querySelector('.article__title');
const titleArticleSummary = articleSummary.getAttribute('dataTitle');
const articleCarousel = document.querySelector('.article_summary_carousel')

let icon_right = '<svg width="24" height="24" viewBox="0 0 24 25" fill="currentColor"><path d="M20.3672 11.4543L11.5125 3.76914C11.4445 3.71055 11.3578 3.67773 11.2664 3.67773H9.19219C9.01875 3.67773 8.93906 3.89336 9.07031 4.00586L17.2781 11.1309H3.5625C3.45937 11.1309 3.375 11.2152 3.375 11.3184V12.7246C3.375 12.8277 3.45937 12.9121 3.5625 12.9121H17.2758L9.06797 20.0371C8.93672 20.152 9.01641 20.3652 9.18984 20.3652H11.3344C11.3789 20.3652 11.4234 20.3488 11.4562 20.3184L20.3672 12.5887C20.4483 12.5181 20.5134 12.431 20.558 12.3331C20.6025 12.2353 20.6256 12.129 20.6256 12.0215C20.6256 11.914 20.6025 11.8077 20.558 11.7098C20.5134 11.612 20.4483 11.5249 20.3672 11.4543Z" fill="currentColor" fill-opacity="0.85"/></svg>'
let icon_left = '<svg width="24" height="24" viewBox="0 0 24 25" fill="currentColor"><path d="M3.63281 12.5887L12.4875 20.2738C12.5555 20.3324 12.6422 20.3652 12.7336 20.3652L14.8078 20.3652C14.9812 20.3652 15.0609 20.1496 14.9297 20.0371L6.72187 12.9121L20.4375 12.9121C20.5406 12.9121 20.625 12.8277 20.625 12.7246L20.625 11.3184C20.625 11.2152 20.5406 11.1309 20.4375 11.1309L6.72422 11.1309L14.932 4.00586C15.0633 3.89102 14.9836 3.67773 14.8102 3.67773L12.6656 3.67774C12.6211 3.67774 12.5766 3.69414 12.5437 3.72461L3.63281 11.4543C3.55168 11.5249 3.48662 11.612 3.44204 11.7098C3.39746 11.8077 3.37439 11.914 3.37439 12.0215C3.37439 12.129 3.39746 12.2353 3.44204 12.3331C3.48662 12.431 3.55168 12.5181 3.63281 12.5887Z" fill="currentColor" fill-opacity="0.85"/></svg>'
let first_html = '<sht-carousel data-section-id="{{ section.id }}"><div class="row js-carousel-items carousel carousel__container article_summary_carousel" role="list" aria-label="Slider">';
let last_html = '</div><div class="carousel__pagination"><button id="carousel__button-prev-PFWEBSITE2-240" type="button" data-step="1" class="carousel__button-prev js-carousel-prev-btn" aria-label="Slide left" name="previous">' + icon_left + '</button><button id="carousel__button-next-PFWEBSITE2-240" type="button" data-step="1" class="carousel__button-next js-carousel-next-btn" aria-label="Slide right" name="next">' + icon_right + '</button></div></sht-carousel>';

function renderDataCarousel(data) {
  let carouselHeading = data.sheet.column1.text;
  let carouselBody = data.sheet.column2.text;
  let pani = carouselHeading.map((e, index) => {
    return `
    <li class="slideshow__pagination__item dots-pagination js-slideshow-pagination-item" data-slideshow-index="${index + 1}"><div class="slideshow__pagination__item--background js-slideshow-pagination-item-background"></div></li>
    `
  });
  let pain_html = '<ul class="slideshow__pagination js-slideshow-pagination d-flex middle-xs ls-none">'+ pani.join('')  +'</ul>'
  carouselHeading.splice(0, 1);
  carouselBody.splice(0, 1);

  let html = carouselHeading.map((e, index) => {
    return `
    <sht-carousel-item role="listitem" tabindex="0" class="col js-carousel-item carousel__item carousel__item-${index + 1} article__carousel" style="--w-xs:12; --w-sm:6;" aria-hidden="false">
      <div class="article__carousel-info">
        <div class="carousel__item--logo">
          <img src="https://cdn.shopify.com/s/files/1/0634/9235/8365/files/PAGEFLY_LOGO_HORIZONTAL_RGB-02_1_6b773bd2-ca36-4f34-b39a-5c2018eb6501.png?v=1690277194" alt="logo">
        </div>
        <h3>${e}</h3>
        <p>${carouselBody[index]}</p>
      </div>
    </sht-carousel-item>
    `
  });
  html.unshift('<sht-carousel-item role="listitem" tabindex="0" class="col js-carousel-item carousel__item carousel__item-0 article__carousel" style="--w-xs:12; --w-sm:6;" aria-hidden="false"><div class="article__carousel-info"><div class="carousel__item--logo"><img src="https://cdn.shopify.com/s/files/1/0634/9235/8365/files/PAGEFLY_LOGO_HORIZONTAL_RGB-02_1_6b773bd2-ca36-4f34-b39a-5c2018eb6501.png?v=1690277194" alt="logo"></div><div class="df key_points"><h3>Key points</h3></div></div></sht-carousel-item>');
  articleCarousel.innerHTML = first_html + html.join('') + pain_html + last_html;
};



let url2 = "https://script.google.com/macros/s/AKfycbwVIcpHKLoHIBdOCohymo8Ifyuq1KuTNRG8x3AU1ECLC-S4CAvnQj35URTV3uCgOlk/exec"
// let url2 = "https://script.google.com/macros/s/AKfycbxQVB0XJdqN1ARRR8XLDbG5BzIBB5DS0bRJf6DvZFzz55F1SUTqmGeoqrcbz8UlOu2xnQ/exec"

url2 += "?title=" + encodeURIComponent(titleArticleSummary);

fetch(url2)
  .then((response) => {
    return response.json();
})
.then((data) => {
  if ( data.isData ) {
    renderDataCarousel(data);
  }
})
.catch(function (error) {
  console.log(error);
});





